export default [
  {
    name: 'Übersicht',
    icon: 'nc-icon nc-bulb-63',
    path: '/ket/overview'
  },
  {
    name: 'Kletterwald',
    icon: 'nc-icon nc-circle-10',
    children: [
      {
        name: 'Anmerkungen',
        path: '/ht/anmerkungen'
      },
      {
        name: 'Protokoll Betriebsbeginn',
        path: '/betriebsbeginn',
        showForLocation: 'NB'
      },
      {
        name: 'Protokoll Betriebsende',
        path: '/betriebsende',
        showForLocation: 'NB'
      },
      {
        name: 'Checkliste HT Start',
        path: '/checklist/HTStart',
        hideForLocation: 'NB'
      },
      {
        name: 'Checkliste HT Ende',
        path: '/checklist/HTEnde',
        hideForLocation: 'NB'
      },
      {
        name: 'Retterstatus',
        path: '/ht/retterstatus'
      },
      {
        name: 'Tagesprotokoll',
        path: '/ht/tagesprotokoll',
        hideForLocation: 'NB'
      },
      {
        name: 'Kontaktliste',
        path: '/ht/kontaktliste'
      },
      {
        name: 'Abseilgeräte',
        path: '/ht/hubgeraete'
      },
      {
        name: 'Unfallprotokoll',
        path: '/print/unfallprotokoll'
      },
      {
        name: 'Newsletter',
        path: '/ht/newsletter'
      },
      {
        name: 'Betriebsordner',
        path: '/ht/betriebsordner'
      },
      {
        name: 'Trainerschlüssel',
        path: '/ht/reportrate'
      },
      {
        name: 'Projekte',
        path: '/ht/projekte'
      },
      {
        name: 'Aufgaben',
        path: '/ht/tasks'
      }
    ]
  },
  {
    name: 'Kasse',
    icon: 'nc-icon nc-bank',
    children: [
      {
        name: 'Checkliste Kasse Start',
        path: '/checklist/KasseStart'
      },
      {
        name: 'Checkliste Kasse Ende',
        path: '/checklist/KasseEnde'
      },
      /*{
        name: 'Basis/Premium Pakete',
        path: '/specials'
      },*/
      {
        name: 'Rabattliste',
        path: '/rabattliste'
      },
      {
        name: 'Kassenstart',
        path: '/kassenstart'
      },
      {
        name: 'Kassenabschluss',
        path: '/kassenabschluss'
      },
      {
        name: 'Hüttencheckliste',
        path: '/checklist/Huette'
      },
      {
        name: 'Liste Kinderprogramme',
        path: '/print/kinderprogramme'
      },
      {
        name: 'Tablets',
        path: '/tablets'
      }
    ]
  },
  {
    name: 'Bau',
    icon: 'nc-icon nc-app',
    children: [
      {
        name: 'Mängel',
        path: '/construction/defects'
      },
      {
        name: 'Inspektionen',
        path: '/construction/inspections'
      },
      {
        name: 'Verpressungen',
        path: '/construction/verpressungen'
      },
      {
        name: 'Parcours',
        path: '/construction/parcours'
      },
    ]
  },
  {
    name: 'PSA',
    icon: 'nc-icon nc-settings',
    children: [
      {
        name: 'Übersicht',
        path: '/psa/overview'
      },
      {
        name: 'Suche',
        path: '/psa/psasearch'
      }
    ]
  },
  {
    name: 'Veranstaltungen',
    icon: 'nc-icon nc-spaceship',
    children: [
      {
        name: 'Veranstaltungen',
        path: '/va/veranstaltungen'
      },
      {
        name: 'Checkliste Start',
        path: '/checklist/VAStart'
      },
      {
        name: 'Checkliste Ende',
        path: '/checklist/VAEnde'
      }
    ]
  },
  {
    name: 'Parkleitung/Büro',
    icon: 'nc-icon nc-laptop',
    children: [
      {
        name: 'Tagesreport',
        path: '/pl/tagesreport'
      },
      {
        name: 'Unterweisungen',
        path: '/pl/unterweisungen'
      },
      {
        name: 'Mitarbeiter',
        path: '/pl/trainer'
      },
      {
        name: 'Händlerkontakte',
        path: '/pl/haendlerkontakte'
      },
      {
        name: 'Zählerstände',
        path: '/pl/zaehlerstand',
        showForLocation: 'FRA'
      },
      {
        name: 'Warenverbrauch',
        path: '/pl/warenverbrauch',
        showForLocation: 'FRA'
      },
      {
        name: 'Bankeinzahlungen',
        path: '/pl/bankeinzahlungen'
      },
      {
        name: 'Toilettenreinigung',
        path: '/pl/toilettenreinigung'
      },
      {
        name: 'Checklisten Büro',
        path: '/checklist/Buero-weekly'
      },
      {
        name: 'Verleih-Liste',
        path: '/pl/verleihliste'
      },
      {
        name: 'Checklisten verwalten',
        path: '/pl/managelists'
      },
      {
        name: 'Vertragsvorlagen',
        path: '/pl/contract-templates'
      },
      {
        name: 'Rabatte verwalten',
        path: '/pl/rabatte'
      },
      {
        name: 'Benutzer verwalten',
        path: '/pl/users'
      }
    ]
  },
  {
    name: 'Trainer',
    icon: 'nc-icon nc-circle-10',
    children: [
      {
        name: 'Aufgaben',
        path: '/ht/tasks'
      },
      {
        name: 'Kontaktliste',
        path: '/ht/kontaktliste'
      },
      {
        name: 'Retterstatus',
        path: '/ht/retterstatus'
      },
      {
        name: 'Betriebsordner',
        path: '/ht/betriebsordner'
      },
      {
        name: 'Newsletter',
        path: '/ht/buschtrommel'
      },
    ]
  },
]
